import { call, take } from 'redux-saga/effects';
import * as categoryGroupListsActions from 'data/categoryGroupLists/categoryGroupListsActions';
import { getLastSyncDate } from 'data/categoryGroupLists/categoryGroupListsSelectors';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';
import { getQcsSyncResources } from 'data/qcsSyncResourceSagaHelpers';

export function* getCategoryGroupListsActionWatcher() {
  while (true) {
    const action = yield take(categoryGroupListsActions.getCategoryGroupListsAction);

    const config = mkQcsSyncResourceConfig({
      resourceName: 'categoryGroupLists',
      resourceBaseUrl: '/category-group-lists',
      getLastSyncDate,
      // transformResponseToResources: ,
      // transformResourceToRequestData:,
      successAction: categoryGroupListsActions.getCategoryGroupListsSuccessAction,
      failureAction: categoryGroupListsActions.getCategoryGroupListsFailureAction,
    });
    yield call(getQcsSyncResources, config, action);
  }
}

export default [getCategoryGroupListsActionWatcher];
